<template>
    <div>
      <trademark-search-type-list></trademark-search-type-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  